;(function() {

   var Grid = {
        $container: null,
        $cells: [],
        cellsPerLine: 3,

        init: function($container, $cellArr, cellsPerLine) {
            this.$container = $container;
            this.$cells = $cellArr;
            this.cellsPerLine = cellsPerLine || 3;

            this.$cells.each(function(i, cell) { cell.style.position = "absolute" });

            this.update();

            // @NOTE(Grey): This a hack to fix the initial janky on load
            setTimeout(function() { $container.removeClass('no-transitions') }, 10);

        },

        fixContainerHeight: function($container, $cells, cellsPerLine) {
            var numberOfCellsHigh = Math.ceil($cells.length / cellsPerLine);
            var cellHeight = $($cells[0]).outerHeight(true);
            $container[0].style.minHeight = numberOfCellsHigh * cellHeight + "px";
        },

        resize: function(cellsPerLine) {
            this.cellsPerLine = cellsPerLine;
            this.update();
        },

        update: function(cb) {
            var $cells = this.$cells;
            var cellsPerLine = this.cellsPerLine;

            this.fixContainerHeight(this.$container, $cells, cellsPerLine);

            // @NOTE(Grey): Splitting the cells out allows for nicer transitions
            // between filter states
            var toRender = [];
            var toHide = [];

            $cells.each(function(i, cell) {
                if ($(cell).hasClass("is-hidden")) {
                    toHide.push(cell);
                } else {
                    toRender.push(cell);
                }
            })

            for (var i = 0; i < toRender.length; ++i) {
                var x = (i % cellsPerLine) * 100;
                var y = (Math.floor(i / cellsPerLine)) * 100;
                var transform = "translateX(" + x + "%) translateY(" + y + "%)";
                toRender[i].style.WebkitTransform = transform;
                toRender[i].style.msTransform = transform;
                toRender[i].style.transform = transform;
            }

            for (var j = 0; j < toHide.length; ++j) {
                var x = (j % cellsPerLine) * 100;
                var y = (Math.floor(j / cellsPerLine)) * 100;
                var transform = "translateX(" + x + "%) translateY(" + y + "%)";
                toHide[j].style.WebkitTransform = transform;
                toHide[j].style.msTransform = transform;
                toHide[j].style.transform = transform;
            }
        }
    };

    var Filter = {
        $container: null,
        $children: null,
        $activeBtn: null,

        init: function(selector) {
            this.$container = $($(selector).data("target"));
            this.$children = this.$container.find(".js-FilterItem");
            this.$activeBtn = $(".js-FilterLink.is-active");

            var $container = this.$container;
            var $children = this.$children;
            var _onClick = this._onClick;
            var _onResize = this._onResize;

            var $win = $(window);
            var $bod = $(document.body);
            var columns = this.setColumns();

            $win.load(function() {
                Grid.init($container, $children, columns);
                // Force a click event on the currently selected query string object
                var filterParam = new URLSearchParams(window.location.search).get('filter') || 'all';
                $('[data-filter=' + filterParam + ']').click();
            });
            $bod.on("click", _onClick.bind(this));
            $win.on("resize", _onResize.bind(this));
        },

        filterTarget: function($activeElement) {
            var filterString = $activeElement.data("filter");

            this.$children.each(function(i, item) {
                var $item = $(item);
                $item.removeClass("is-hidden");
                if (filterString !== "all" && $item.data("type") !== filterString) {
                    $item.addClass("is-hidden");
                }
            });
        },

        // Solution taken from: https://stackoverflow.com/a/41542008
        // @NOTE(Grey): Does not work in any IE browsers or many phone browsers
        updateURL: function(filterStr) {
            if ('URLSearchParams' in window) {
                var filterParams = new URLSearchParams(window.location.search);
                filterParams.set("filter", filterStr);
                var newRelativePathQuery = window.location.pathname + "?" + filterParams.toString();
                history.pushState(null, "", newRelativePathQuery);
            }
        },

        setColumns: function() {
            var width = window.innerWidth;

            var num = 1;
            if (width >= 680) { num = 2; }
            if (width >= 750) { num = 3; }

            return num;
        },

        _onClick: function(event) {
            var $target = $(event.target);

            if ($target.hasClass("js-FilterLink")) {
                this.$activeBtn.removeClass("is-active");
                $target.addClass("is-active");

                this.$activeBtn = $target;

                this.filterTarget(this.$activeBtn);
                this.updateURL($target.data("filter"));
                Grid.update();

                event.preventDefault();
            }
        },

        _onResize: function(event) {
            var columns = this.setColumns();
            Grid.resize(columns);
        }

    };

    if ($(".js-Filter").length) {
        Filter.init(".js-Filter")
    }
}());
